import React, { Component } from 'react';
// import logo from './../../logo.svg';
// import style from './../../style.jpg';
// import  Myconponent  from './mycomponent.js'

  // router 


class Addinput extends Component {
   
    // onChange(event){
    //     console.log(event.target.value)
    // }




    constructor(props){
        super(props);
        

            /// state
            this.state ={
                title:"APP TITLE",
                checked : false,
                show:false
            }

        
    }

    // onSubmit(){
    //     console.log("clicke")
    //     this.setState({
    //         title : "change title for good",
    //         name : "new app name ",
    //         contect : "new type app contect"
    //     })
    // }

    onSubmit=(event)=>{
        event.preventDefault();
     var  data = {
            field : this.field.value,
            value : this.value.value
        }
        this.props.getdata(data)
        this.field.value = ""
        this.value.value = ""
    }
    
 
    render(){
     const list =[
      "Item 1",
      "item 1",
      "Another Item"

     ]

        return(
           
            
           <div>
                   <div class="columns">
                    <div class="column is-half">
                        <div class="field">
                            <small>Feature Name</small>
                            <div class="control">
                                <input class="input" type="text"  ref={input =>this.field = input}  placeholder="Eg : Color" />
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="field">
                            <small>Description</small> 
                            <div class="control">
                                <input class="input" type="text" ref={input =>this.value = input} placeholder="Eg : Black" />
                            </div>
                        </div>
                    </div>
                    
                    
                </div>
                <a class="button is-primary is-rounded is-small" onClick={this.onSubmit} style={{textAlign:"right"}}><i class="fas fa-plus"></i></a>
               

           </div>
                 
      


         
        )
    }






}

export default Addinput;


// WEBPACK FOOTER //
// ./src/component/company/addinput.js